import React from 'react';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import { withInjectedValue } from './with-injected-value';
import { useDraftEditorStateValue } from './utils/use-draft-editor-state-value';
import { AudioToolbar } from './with-audio/AudioToolbar';
import { LEARNING_SUBJECT } from '../../utils/constants';

export const withAudio = (DraftEditorComponent) => {
  const InjectedDraftEditor = withInjectedValue(DraftEditorComponent);

  const WithAudioEditor = (props) => {
    const {
      value: propValue,
      toolbarCustomButtons: toolbarCustomButtonsProp = [],
      learningSubject = LEARNING_SUBJECT.chineseMandarin.value,
    } = props;

    const { value, setValue, draftEditorState, setDraftEditorState } = useDraftEditorStateValue({
      ...props,
      value: omit(propValue, 'audioFileKey'),
    });

    const handleChange = (value) => {
      setValue(value);
    };

    const handleDraftEditorStateChange = (draftEditorState) => {
      setDraftEditorState(draftEditorState);
    };

    const handleAudioChange = ({ audioFileKey, audioFileUrl }) => {
      setValue((prevValue) => {
        return {
          ...prevValue,
          audioFileKey: audioFileKey ?? null,
          audioFileUrl,
        };
      });
    };

    const toolbarCustomButtons = [
      <AudioToolbar
        key="edit-audio"
        value={value}
        draftEditorState={draftEditorState}
        learningSubject={learningSubject}
        onAudioChange={handleAudioChange}
      />,
      ...toolbarCustomButtonsProp,
    ];

    return (
      <InjectedDraftEditor
        {...props}
        toolbarCustomButtons={toolbarCustomButtons}
        value={value}
        onDraftEditorStateChange={handleDraftEditorStateChange}
        onChange={handleChange}
      />
    );
  };

  WithAudioEditor.propTypes = {
    ...InjectedDraftEditor.propTypes,
    draftEditorState: PropTypes.object,
    value: PropTypes.shape({
      html: PropTypes.string.isRequired,
      audioFileKey: PropTypes.string,
      audioUrl: PropTypes.string,
    }),
    learningSubject: PropTypes.string,
  };

  const PossiblyWithAudioEditor = (props) => {
    const { withAudio: withAudioProp, ...draftEditorProps } = props;

    if (!withAudioProp) {
      return <InjectedDraftEditor {...draftEditorProps} />;
    }

    return <WithAudioEditor {...draftEditorProps} />;
  };

  PossiblyWithAudioEditor.propTypes = {
    ...WithAudioEditor.propTypes,
    withAudio: PropTypes.bool,
  };

  PossiblyWithAudioEditor.isValueInjected = true;

  return PossiblyWithAudioEditor;
};
